import React, { memo, useEffect, useState, useRef } from "react";
import { FiTrash2 } from "react-icons/fi";
import { getPrice, getOptimizedUrl } from "../../../constants/globalFunction";
import { colors } from "../../../constants/colors";
import { RUPEE } from "../../../constants/globalConstants";
import "./CartProductDrawer.css";

const CartProductDrawer = ({
  item,
  onIncreaseQty,
  onDecreaseQty,
  onUpdateQty,
  selectedItem,
}) => {
  const { image, size } = item;
  const [price, setPrice] = useState(0);
  const [inputQuantity, setInputQuantity] = useState(item?.qty?.toString());
  const inputRef = useRef(null);

  useEffect(() => {
    if (item) {
      setInputQuantity(item?.qty?.toString());
      const fetchPrice = async () => {
        const p = await getPrice(item?.size);
        setPrice(p || 0);
      };
      fetchPrice();
    }
  }, [item]);

  const onIncrease = () => {
    onIncreaseQty(item);
  };

  const onDecrease = () => {
    onDecreaseQty(item, false);
  };

  const onDelete = () => {
    onDecreaseQty(item, true);
  };

  const onPressProduct = () => {
    const productUrl = `/product?product_id=${item?._id}`;
    window.open(productUrl, "_blank");
  };

  const handleQuantityBlur = () => {
    const newQty = parseInt(inputQuantity);
    if (newQty && newQty !== item?.qty && newQty > 0) {
      onUpdateQty(item, newQty);
    } else {
      setInputQuantity(item?.qty?.toString());
    }
  };

  const handleQuantityChange = (e) => {
    const value = e.target.value;
    if (value === "" || /^\d+$/.test(value)) {
      setInputQuantity(value);
    }
  };

  const handleQuantityKeyPress = (e) => {
    if (e.key === "Enter") {
      inputRef.current?.blur();
    }
  };

  return (
    <div
      className="cart-product-drawer"
      // onClick={onPressProduct}
    >
      <div className="cart-product-drawer-row">
        <img
          src={getOptimizedUrl(image?.image)}
          alt={item?.name}
          className="cart-product-drawer-image"
          loading="lazy"
        />
        <div className="cart-product-drawer-details">
          <h3 className="cart-product-drawer-name" title={item?.name}>
            {item?.name}
          </h3>
          <p className="cart-product-drawer-detail">
            {[item?.color?.name, size?.size, item?.fabric]
              .filter(Boolean)
              .join(" / ")}
          </p>
          <div className="cart-product-drawer-price-row">
            <span className="cart-product-drawer-price">
              {RUPEE}
              {price}
            </span>
          </div>
          <div className="cart-product-drawer-controls">
            {!item?.is_update ? (
              <>
                <div className="cart-drawer-quantity-box">
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      onDecrease();
                    }}
                    className="cart-drawer-qty-btn"
                  >
                    −
                  </button>
                  <input
                    ref={inputRef}
                    type="text"
                    value={inputQuantity}
                    onChange={handleQuantityChange}
                    onBlur={handleQuantityBlur}
                    onKeyPress={handleQuantityKeyPress}
                    className="cart-drawer-qty-input"
                  />
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      onIncrease();
                    }}
                    className="cart-drawer-qty-btn"
                  >
                    +
                  </button>
                </div>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    onDelete();
                  }}
                  className="cart-drawer-delete-btn"
                >
                  <FiTrash2 size={15} color={colors.black} />
                </button>
              </>
            ) : (
              <>
                <span className="cart-drawer-unavailable-text">
                  Unavailable
                </span>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    onDelete();
                  }}
                  className="cart-drawer-delete-btn"
                >
                  <FiTrash2 size={15} color={colors.black} />
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(CartProductDrawer);
